import React from "react";
import { useTranslation } from "react-i18next";

interface SDAStepsProps {
  current: 1 | 2 | 3 | 4 | 5 | 6 | 7;
}

const STEP_KEYS = [
  { id: 1, key: "sda.steps.info" },
  { id: 2, key: "sda.steps.identity" },
  { id: 3, key: "sda.steps.financial" },
  { id: 4, key: "sda.steps.underwriting" },
  { id: 5, key: "sda.steps.quote" },
  { id: 6, key: "sda.steps.signatures" },
  { id: 7, key: "sda.steps.payment" },
];

const SDASteps: React.FC<SDAStepsProps> = ({ current }) => {
  const { t } = useTranslation();
  const STEPS = STEP_KEYS.map((s) => ({ id: s.id, label: t(s.key) }));

  return (
    <ol className="mb-6 flex items-center gap-2 text-xs font-medium">
      {STEPS.map((step, idx) => {
        const isActive = step.id === current;
        const isComplete = step.id < current;
        return (
          <React.Fragment key={step.id}>
            <li className="flex items-center gap-2">
              <span
                className={`flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-xs ${
                  isActive
                    ? "bg-primary text-white"
                    : isComplete
                      ? "bg-success text-white"
                      : "bg-gray-200 text-gray-500"
                }`}
              >
                {isComplete ? (
                  <svg className="h-3 w-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                ) : (
                  step.id
                )}
              </span>
              <span
                className={`hidden sm:inline ${
                  isActive ? "text-primary" : isComplete ? "text-gray-700" : "text-gray-400"
                }`}
              >
                {step.label}
              </span>
            </li>
            {idx < STEPS.length - 1 && (
              <li
                className={`h-px flex-1 ${
                  isComplete ? "bg-success" : "bg-gray-200"
                }`}
              />
            )}
          </React.Fragment>
        );
      })}
    </ol>
  );
};

export default SDASteps;
